import { Form, Modal } from 'semantic-ui-react';
import {
    TaskExecutionDetailsType,
    TaskExecutionInfoType,
    TaskExecutionUpdateSchemaType,
} from '../../../../schemas/task.schemas';
import { CompanyType } from '../../../../types/company.types';
import TaskExecutionUpdateForm from '../taskExecutionUpdateForm';
import { TASK_STATUS } from '../../../../constnats/task';
import '../form.styles.css'

type TaskExecutionModalPropsType = {
    execution?: Pick<TaskExecutionInfoType, 'id' | 'notes' | 'status' | 'taskId' | 'entityId'> &
        Partial<Pick<TaskExecutionDetailsType, 'taskDescription' | 'taskTitle'>>;
    open: boolean;
    onCancel: () => void;
    onSave: (data: TaskExecutionUpdateSchemaType) => void;
    companies: CompanyType[];
};

function TaskExecutionUpdateModal({ execution, open, onCancel, onSave, companies }: TaskExecutionModalPropsType) {
    return (
        <Modal open={open} onClose={onCancel}>
            <Modal.Content>
                {execution && (
                    <>
                        {(execution.taskDescription || execution.taskTitle) && (
                            <Form className='task__form'>
                                {execution.taskTitle && (
                                    <Form.Input
                                        disabled={true}
                                        value={execution.taskTitle}
                                        fluid
                                        label="Title"
                                        placeholder="Create Margin Field"
                                    />
                                )}
                                {execution.taskDescription && (
                                    <Form.TextArea
                                        disabled={true}
                                        value={execution.taskDescription}
                                        label="Description"
                                        rows={8}
                                    />
                                )}
                            </Form>
                        )}
                        <TaskExecutionUpdateForm
                            execution={execution}
                            companies={companies}
                            onCancel={onCancel}
                            onSave={onSave}
                            readOnly={execution?.status === TASK_STATUS.COMPLETED}
                        />
                    </>
                )}
            </Modal.Content>
        </Modal>
    );
}

export default TaskExecutionUpdateModal;
